import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.404 7.65q4.06-.316 6.818-.317 2.758 0 6.818.318a3.89 3.89 0 0 1 3.576 3.602q.047.649.08 1.334l3.225-1.613a1.667 1.667 0 0 1 2.412 1.49v7.516a1.667 1.667 0 0 1-2.412 1.49l-3.226-1.613q-.032.685-.079 1.335a3.89 3.89 0 0 1-3.576 3.602q-4.055.317-6.818.317t-6.818-.317a3.89 3.89 0 0 1-3.576-3.602 71 71 0 0 1-.161-4.97q0-2.697.16-4.97a3.89 3.89 0 0 1 3.577-3.601M23.743 18.64l3.675 1.838a.556.556 0 0 0 .804-.497v-7.516a.555.555 0 0 0-.804-.497l-3.675 1.838q.035 1.162.035 2.417t-.035 2.417M6.49 8.759a2.78 2.78 0 0 0-2.555 2.573 70 70 0 0 0-.158 4.89q0 2.66.158 4.891a2.78 2.78 0 0 0 2.555 2.573q4.016.314 6.731.314t6.732-.314a2.78 2.78 0 0 0 2.554-2.573 70 70 0 0 0 .159-4.89q0-2.66-.159-4.891a2.78 2.78 0 0 0-2.554-2.573q-4.02-.315-6.732-.314-2.71 0-6.731.314",
      clipRule: "evenodd"
    }
  )
);
var SvgVideoOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VideoOutlined_default = SvgVideoOutlined;

export { VideoOutlined_default as default };
